import type {
  CrudFormItem,
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type {
  LiveRetainedForm,
  LiveRetainedRecord
} from './live-retained-statistics.service'

export function createLiveRetainedSearchItems(
  channels: CrudSelectOption[],
  loading: boolean
): CrudSearchItem[] {
  const controlClass = 'live-retained-page__search-control'
  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      controlClass,
      clearable: true,
      loading,
      placeholder: '请选择直播间',
      options: channels
    },
    {
      label: '筛选日期',
      prop: 'timeSlot',
      type: 'dateRange',
      controlClass,
      columnSpan: 2,
      valueFormat: 'YYYY-MM-DD',
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => date.getTime() > Date.now()
    }
  ]
}

export function createLiveRetainedFormItems(
  channels: CrudSelectOption[]
): CrudFormItem<LiveRetainedForm>[] {
  return [
    {
      label: '直播间',
      prop: 'channelId',
      type: 'select',
      placeholder: '请选择直播间',
      options: channels
    },
    {
      label: '观看时长',
      prop: 'timeLong',
      type: 'input',
      placeholder: '请输入观看时长（单位：分钟）'
    },
    {
      label: '时间范围',
      prop: 'timeSlot',
      type: 'slot',
      slot: 'timeRange'
    }
  ]
}

export const liveRetainedTableColumns: CrudTableColumn<LiveRetainedRecord>[] = [
  {
    prop: 'channelName',
    label: '直播间',
    minWidth: 100,
    showOverflowTooltip: true
  },
  { prop: 'timeLong', label: '观看时长（分钟）', minWidth: 100 },
  {
    prop: 'timeSlot',
    label: '统计时间段',
    minWidth: 120,
    showOverflowTooltip: true
  },
  {
    prop: 'statisticsNum',
    label: '统计量',
    minWidth: 80,
    sortable: 'custom'
  },
  {
    prop: 'totalNum',
    label: '观看总量',
    minWidth: 80,
    sortable: 'custom'
  },
  { prop: 'retainedRate', label: '观看留存率', minWidth: 80 },
  { label: '操作', slot: 'rowActions', minWidth: 60 }
]
